import styled from 'styled-components';
import { media, colors, fonts } from 'settings/style';

export const PageShell = styled.div`
  background: #ffffff;
  padding-bottom: 2rem;
`;

export const PageHeader = styled.header`
  padding: 2.25rem 0 1.5rem;
  max-width: 100%;
  font-family: 'Inter', system-ui, -apple-system, 'Segoe UI', sans-serif;

  ${media.md`
    padding: 1.5rem 0 1.25rem;
  `}
`;

export const PageTitle = styled.h1`
  margin: 0 0 8px;
  font-family: ${fonts.tertiary};
  font-size: 2.25rem;
  color: ${colors.grey900};

  ${media.md`
    font-size: 1.75rem;
  `}
`;

export const PageHeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  flex-wrap: nowrap;

  ${PageTitle} {
    margin-bottom: 0;
    flex: 1;
    min-width: 0;
  }
`;

export const PageHeaderAction = styled.div`
  flex-shrink: 0;

  .ant-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    white-space: nowrap;
  }
`;

export const PageSubtitle = styled.p`
  margin: 0;
  font-size: 1.0625rem;
  font-weight: 400;
  color: #667085;
  line-height: 1.5;
  max-width: 42rem;

  ${media.md`
    font-size: 0.9375rem;
  `}
`;

export const CategoriesSection = styled.section`
  margin-bottom: 1.75rem;
`;

export const GroupListWrapper = styled.div`
  padding: 0 0 1.5rem;
  flex: 1;
  min-width: 0;
  width: 100%;
  background: #ffffff;
  font-family: 'Inter', system-ui, -apple-system, 'Segoe UI', sans-serif;

  ${media.md`
    padding: 0 0 1rem;
  `}
`;

export const MyGroupsSections = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2.5rem;
  padding-top: 2rem;

  ${media.md`
    gap: 2rem;
    padding-top: 1.5rem;
  `}
`;
